import { ValidationErrors, AbstractControl, Validators } from '@angular/forms';


export module CustomValidators {
  export function blankValidator(control: AbstractControl): ValidationErrors | null {
    let value: string = control.value;
    if (value==null || !value.trim())
      return {blank: true};

    return null;
  }
}
